import {
  applyMiddleware,
  createStore,
  compose,
  Store,
  Middleware,
} from 'redux';
import createSagaMiddleware from 'redux-saga';
import logger from 'redux-logger';

import rootReducer, { StoreState } from '../reducers';
import { Action } from '../actions';
import * as actionsCreators from '../actionCreators';

const sagaMiddleware = createSagaMiddleware();
const middlewares: Middleware[] = [sagaMiddleware];
if (__DEV__) {
  middlewares.push(logger);
}
let store: Store<StoreState, Action>;

export default function configureStore(): {
  runSaga: typeof sagaMiddleware.run;
  store: Store<StoreState, Action>;
} {
  const composeEnhancers =
    typeof window === 'object' &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          actionsCreators,
        })
      : compose;

  const enhancer = composeEnhancers(applyMiddleware(...middlewares));

  store = createStore(rootReducer, enhancer);
  return {
    runSaga: sagaMiddleware.run,
    store,
  };
}
